import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f8c79806&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c79806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8c79806')) {
      api.createRecord('f8c79806', component.options)
    } else {
      api.reload('f8c79806', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f8c79806&scoped=true&", function () {
      api.rerender('f8c79806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aEMnt2TdMfVB/JS/comp/Accordion.vue"
export default component.exports